import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../lib/utils/consts';
import React, { useState } from 'react';
import { UiKit, Button } from '@datavant/uikit';
import { ChatIcon } from '@chakra-ui/icons';
import { getRingCentralChat } from '../forms/selfServeOnboarding/sections/RingCentral';

export const HelpFooter = (props: {
    supportPhoneOverwrite?: string;
    supportEmailOverwrite?: string;
    hideLiveChat?: boolean;
}) => {
    const [isLiveChatOpen, setIsLiveChatOpen] = useState(false);
    return (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.Box textAlign={'center'}>
                <UiKit.Chakra.Text as={'h3'} fontSize={16} fontWeight={500}>
                    Help
                </UiKit.Chakra.Text>
                <UiKit.Chakra.Text>Phone: {props.supportPhoneOverwrite ?? SUPPORT_PHONE}</UiKit.Chakra.Text>
                <UiKit.Chakra.Text>Email: {props.supportEmailOverwrite ?? SUPPORT_EMAIL}</UiKit.Chakra.Text>
            </UiKit.Chakra.Box>
            {
                // Hide live chat button if hideLiveChat is true
                !props.hideLiveChat && (
                    <Button
                        buttonAppearance={'outline'}
                        leftIcon={<ChatIcon />}
                        onClick={() => {
                            if (isLiveChatOpen) {
                                getRingCentralChat().hide();
                            } else {
                                getRingCentralChat().show();
                            }
                            setIsLiveChatOpen(!isLiveChatOpen);
                        }}
                    >
                        {isLiveChatOpen ? 'Close Chat' : 'Live Chat'}
                    </Button>
                )
            }
        </UiKit.Chakra.VStack>
    );
};
